"use strict";

import parameterServices from "dias/foerderregeln/parameter/services";


const parametermodule = angular.module("dias.foerderregeln.parameter.astorgFilter", [
  parameterServices.name,
])

  .config(function(ParametermoduleRegistryProvider) {
    ParametermoduleRegistryProvider.register("astorg_filter", "parametermodul-json");
  })
;
export default parametermodule;
